import React, { Component, useReducer } from 'react';
import {Collapse, OverviewToggler,OverviewBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import {IoMdFitness} from 'react-icons/io'
import {AiOutlineCalendar, AiOutlineVideoCameraAdd} from 'react-icons/ai'
import {BiDumbbell} from 'react-icons/bi'
import {GiKnifeFork} from 'react-icons/gi'
import AddWorkout from './add_workout'
import AddNutritionalPlan from './add_nutritional_plans'
import AddTrainingProgram from './add_training_program'
import AddPackages from './add_packages'
import AddOrgTrainers from './add_org_trainers'
import BookSession from './scheduler'
import programs from './programs';
import AddLive from './add_live'
import Loading from '../images/loading.png'

  class Overview extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          current_render: 'overview',
          clients: [],
          sessions: [],
          workouts: [],
          nutritional_plans: [],
          training_programs: [],
          loading: true
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.ChangeRender = (selected_render) => {
        this.setState({current_render: selected_render})
      }

      this.CurrentRender = () => {
        var current_render = this.state.current_render
        var clients = this.state.clients.length
        var sessions = this.state.sessions.length
        var workouts = this.state.workouts.length
        var nutritional_plans = this.state.nutritional_plans.length
        var training_programs = this.state.training_programs.length

        if(current_render == 'overview'){
          return<Row style={{margin: '0px'}}>
            <Col>
              <Row style={{border: '1px solid #DCE1E5', minHeight: '30px', alignItems: 'center', justifyContent: 'center'}}>
                <h5 style={{textAlign: 'left'}}>
                  Stats
                </h5>
              </Row>
              <Row style={{border: '1px solid #DCE1E5', minHeight: '300px'}}>
                <Col>
                  <br/><br/>
                  <Row>
                    <Col>
                      <div style={{height: '100px', width: '100px', border: '3px solid #1faced', borderRadius: '50%'}}>
                        <br/>
                        Clients:
                        <br/>
                        {clients}
                      </div>
                    </Col>
                    <Col>
                      <div style={{height: '100px', width: '100px', border: '3px solid #1faced', borderRadius: '50%'}}>
                        <br/>
                        Programs:
                        <br/>
                        {training_programs}
                      </div>
                    </Col>
                  </Row>
                  <br/>
                  <Row>
                    <Col>
                      <div style={{height: '100px', width: '100px', border: '3px solid #1faced', borderRadius: '50%'}}>
                        <br/>
                        Workouts:
                        <br/>
                        {workouts}
                      </div>
                    </Col>
                    <Col>
                      <div style={{height: '100px', width: '100px', border: '3px solid #1faced', borderRadius: '50%'}}>
                        <br/>
                        Nutrition:
                        <br/>
                        {nutritional_plans}
                      </div>
                    </Col>
                  </Row>
                  <br/><br/>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col>
                  <Button onClick={() => this.ChangeRender('add_training_programs')} style={{border: '1px solid #DCE1E5', backgroundColor: 'inherit', color: 'inherit', width: '100%', height: '150px'}}>
                    <div style={{margin: '5px', alignItems: 'center', justifyContent: 'center'}}>
                      <IoMdFitness size="20px"/> 
                      <br/>
                      Add Program
                    </div>
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => this.ChangeRender('book_session')} style={{border: '1px solid #DCE1E5', backgroundColor: 'inherit', color: 'inherit', width: '100%', height: '150px'}}>
                    <div style={{margin: '5px', alignItems: 'center', justifyContent: 'center'}}>
                      <AiOutlineCalendar size='20px'/>
                      <br/>
                      Book Session
                    </div>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button onClick={() => this.ChangeRender('create_workout')} style={{border: '1px solid #DCE1E5', backgroundColor: 'inherit', color: 'inherit', width: '100%', height: '150px'}}>
                    <div style={{margin: '5px', alignItems: 'center', justifyContent: 'center'}}>
                      <BiDumbbell size='20px'/>
                      <br/>
                      Create Workout
                    </div>
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => this.ChangeRender('create_nutritional_plan')} style={{border: '1px solid #DCE1E5', backgroundColor: 'inherit', color: 'inherit', width: '100%', height: '150px'}}>
                    <div style={{margin: '5px', alignItems: 'center', justifyContent: 'center'}}>
                      <GiKnifeFork size='20px'/>
                      <br/>
                      Create Nutritional Plan
                    </div>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm='6'>
                  <Button onClick={() => this.ChangeRender('add_live')} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit', width: '100%'}}>
                    <div style={{margin: '5px', alignItems: 'center', justifyContent: 'center'}}>
                      <AiOutlineVideoCameraAdd size='15px'/>
                      <br/>
                      Start Live Session
                    </div>
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        }else if(current_render == 'add_training_programs'){
          return<AddTrainingProgram all_clients={this.props.all_clients}/>
        }else if(current_render == 'book_session'){
          return<div style={{margin: '0px', marginTop: '-110px', width: '100%'}}>
            <BookSession all_clients={this.props.all_clients}/>
          </div>
        }else if(current_render == 'create_workout'){
          return<AddWorkout all_clients={this.props.all_clients}/>
        }else if(current_render == 'create_nutritional_plan'){
          return<AddNutritionalPlan all_clients={this.props.all_clients}/>
        }else if(current_render == 'add_packages'){
          return<AddPackages all_clients={this.props.all_clients}/>
        }else if(current_render == 'add_org_trainers'){
          return<AddOrgTrainers all_clients={this.props.all_clients}/>
        }else if(current_render == 'add_live'){
          return<AddLive all_clients={this.props.all_clients}/>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'allClients', data)
      .then((res) => {
          let result = res.data
            this.setState({clients: result})
      }).catch((error) => {
          console.log(error)
      })

      
      axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
      .then(res => {
        let result = res.data
        data.append('trainer_id', result._id.$oid)
        axios.post(Backend_Url + 'getTrainerFitnessPlansCatalogue', data)
        .then((res) => {
            let result = res.data
            this.setState({training_programs: result})
        }).catch((error) => {
            console.log(error)
        })
      }).catch((error) => {
        console.log(error);
      });

      axios.post(Backend_Url + 'getTrainerSchedule', data)
      .then((res) => {
          let result = res.data
            this.setState({sessions: result})
      }).catch((error) => {
          console.log(error)
      })

      axios.post(Backend_Url + 'getTrainerWorkouts', data)
      .then((res) => {
          let result = res.data
            this.setState({workouts: result})
      }).catch((error) => {
          console.log(error)
      })

      axios.post(Backend_Url + 'getTrainerNutritionalPlans', data)
      .then((res) => {
          let result = res.data
            this.setState({nutritional_plans: result, loading: false})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      if(this.state.loading){
        return (
          <Row>
              <Helmet>
                <title>CLIENTS - ONFIT</title>
                {/* <meta name="description" content="" /> */}
              </Helmet>
              <div style={{minHeight: '900px', backgroundColor: '#ffffff', opacity: 0.9}}>
                <br/><br/>
                <img src={Loading} style={{width: '30%'}}/>
                <br/><br/><br/>
              </div>
          </Row>
        );
      }
      
      return (
        <Row>
            <Helmet>
              <title>TRAINER OVERVIEW - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Overview
              </h4>
              <br/><br/>
              <Container>
                <this.CurrentRender/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Overview);